import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          email_address: 'Email Address',
          email_placeholder: 'Enter your email',
          password: 'Password',
          sign_in: 'Sign In',
          signing_in: 'Signing In...',
          dont_have_account: "Don't have an account?",
          sign_in_to_your_account: 'Sign in to your\nAccount',
          sign_in_subtitle: 'Enter your email and password to log in',
          sign_up_free: 'Sign up for free',
          confirm_password: 'Confirm Password',
          already_have_account: 'Already have an account?',
          create_account: 'Create Account',
          creating_account: 'Creating Account...',
          get_started_with_reels: 'Get started today',
          full_name: 'Full Name',
          enter_name: 'Enter your name',
          create_password: 'Create a password',
          confirm_your_password: 'Confirm your password',
          verify_otp_title: 'Verify your OTP',
          verify_otp_desc: 'Please enter the 6-digit code sent to your email',
          otp_code: 'OTP Code',
          verify_otp: 'Verify OTP',
          verifying: 'Verifying...',
          resend_otp_question: "Didn't receive code? Resend",
          resending: 'Resending...',
          back_to_login: 'Back to Login',
          forgot_password_title: 'Forgot Password',
          forgot_password_desc: 'Enter your email to receive an OTP for password reset',
          remember_password: 'Remember your password?',
          send_otp: 'Send OTP',
          sending_otp: 'Sending OTP...',
          forgot_password_question: 'Forgot password?',
          new_password: 'New Password',
          enter_new_password: 'Enter new password',
          confirm_new_password: 'Confirm New Password',
          reset_password: 'Reset Password',
          resetting: 'Resetting...',
          reset_password_title: 'Reset Password',
          reset_password_desc: 'Enter your new password below',
          // Validation Errors
          email_required: 'Email is required',
          invalid_email: 'Invalid email address',
          password_required: 'Password is required',
          password_too_short: 'Password must be at least 6 characters',
          otp_required: 'OTP is required',
          otp_length_6: 'OTP must be 6 digits',
          passwords_must_match: 'Passwords must match',
          confirm_password_required: 'Confirm password is required',
          name_required: 'Name is required',
          slug_required: 'Slug is required',
          app_name_required: 'App name is required',
          app_email_required: 'App email is required',
          support_email_required: 'Support email is required',
          // Status and Response Messages
          otp_sent_successfully: 'OTP sent successfully',
          failed_to_send_otp: 'Failed to send OTP',
          otp_verified_successfully: 'OTP verified successfully',
          invalid_otp: 'Invalid OTP code',
          otp_resent_successfully: 'OTP resent successfully',
          failed_to_resend_otp: 'Failed to resend OTP',
          password_reset_successfully: 'Password reset successfully',
          failed_to_reset_password: 'Failed to reset password',
          login_successful: 'Login successful',
          login_failed: 'Login failed',
          account_created_successfully: 'Account created successfully',
          registration_failed: 'Registration failed',
          // Header & Sidebar
          search_placeholder: 'Search AI tools, templates, and more...',
          profile: 'Profile',
          subscriptions: 'Subscriptions',
          settings: 'Settings',
          sign_out: 'Sign Out',
          sign_out_confirm:
            'Are you sure you want to sign out? You will need to enter your credentials to access your account again.',
          cancel: 'Cancel',
          confirm: 'Confirm',
          logged_out_successfully: 'Logged out successfully',
          guest: 'Guest',
          dashboard: 'Dashboard',
          revenue_overview_desc: 'Real-time financial activity and trends',
          failed_to_load_dashboard: 'Failed to load dashboard data.',
          pending: 'Pending',
          user_subscriptions: 'User Subscriptions',
          subscription_overview: 'Overview of user subscription plans',
          role_distribution: 'Role Distribution',
          role_distribution_desc: 'Node allocation across permission levels',
          recent_users: 'Recent Users',
          user_dashboard_promo:
            'Explore your AI-powered tools and start creating amazing content today. Your journey to efficiency starts here.',
          text_to_image: 'Text to Image',
          image_to_image: 'Image to Image',
          // Help Center
          add_faq: 'Add FAQ',
          faq_desc: 'Manage your FAQs here.',
          faq_deleted_successfully: 'FAQ deleted successfully',
          failed_to_delete_faq: 'Failed to delete FAQ',
          failed_to_update_status: 'Failed to update status',
          no_faqs_found: 'No FAQs found. Create one to get started.',
          edit_faq: 'Edit FAQ',
          create_faq: 'Create FAQ',
          faq_updated_successfully: 'FAQ updated successfully',
          faq_created_successfully: 'FAQ created successfully',
          something_went_wrong: 'Something went wrong',
          update: 'Update',
          create: 'Create',
          active: 'Active',
          title: 'Title',
          description: 'Description',
          status: 'Status',
          currency: 'Currency',
          select_currency: 'Select Currency',
          last_updated: 'Last Updated',
          actions: 'Actions',
          edit: 'Edit',
          delete: 'Delete',
          enter_faq_title: 'Enter FAQ title',
          enter_faq_description: 'Enter FAQ description',
          credits: 'Credits',
          upgrade_now: 'Upgrade Now',
          faq: 'FAQ',
          ai_power_enabled: 'AI Power Enabled',
          credits_available: 'Credits Available',
          // Media Library
          media_library: 'Media Library',
          media_library_desc: 'Centralized media storage and management.',
          upload_media: 'Upload Media',
          media_deleted_successfully: 'Media deleted successfully',
          failed_to_delete_media: 'Failed to delete media',
          no_media_found: 'No media found. Upload some files to get started.',
          delete_media_title: 'Delete Media',
          delete_media_description: 'Are you sure you want to delete this media? This action cannot be undone.',
          select_media: 'Select Media',
          uploading_media: 'Uploading Media...',
          files_selected: 'Files Selected',
          drop_files_here: 'Drop files here or click to upload',
          max_files_hint: 'You can upload up to 10 files at once.',
          files_uploaded_successfully: 'Files uploaded successfully',
          failed_to_upload_media: 'Failed to upload media',
          bulk_media_deleted_successfully: '{{count}} media items deleted successfully',
          delete_selected: 'Delete Selected',
          cancel_selection: 'Cancel Selection',
          select_multiple: 'Select Multiple',
          deselect_all: 'Deselect All',
          selected_of: 'selected of',
          bulk_delete_media_title: 'Delete Selected Media',
          bulk_delete_media_description:
            'Are you sure you want to delete the selected media items? This action cannot be undone.',
          // Pages Management
          pages_title: 'Web Pages',
          pages_desc: 'View and manage system pages.',
          add_page: 'Add Page',
          edit_page: 'Edit Page',
          create_page: 'Create Page',
          page_created_successfully: 'Page created successfully',
          page_updated_successfully: 'Page updated successfully',
          page_deleted_successfully: 'Page deleted successfully',
          failed_to_delete_page: 'Failed to delete page',
          no_pages_found: 'No pages found.',
          delete_page_title: 'Delete Page',
          delete_page_description: 'Are you sure you want to delete this page? This action cannot be undone.',
          slug: 'Slug',
          // Blogs Management
          blog_management: 'Blog Management',
          manage_blogs_categories_and_tags: 'Manage blogs, categories, and tags.',
          blogs: 'Blogs',
          categories: 'Categories',
          add_blog: 'Add Blog',
          edit_blog: 'Edit Blog',
          delete_blog_title: 'Delete Blog',
          delete_blog_description: 'Are you sure you want to delete this blog post? This action cannot be undone.',
          add_category: 'Add Category',
          edit_category: 'Edit Category',
          delete_category: 'Delete Category',
          delete_category_description: 'Are you sure you want to delete this category? This action cannot be undone.',
          add_tag: 'Add Tag',
          category_deleted_successfully: 'Category deleted successfully',
          blog_deleted_successfully: 'Blog deleted successfully',
          featured: 'Featured',
          manage_blog_categories: 'Manage blog categories and hierarchies.',
          manage_blog_tags: 'Manage blog tags for better searchability.',
          search_categories: 'Search categories...',
          enter_category_name: 'Enter category name',
          enter_category_slug: 'Enter category slug',
          enter_tag_title: 'Enter tag title',
          category_updated_successfully: 'Category updated successfully',
          category_created_successfully: 'Category created successfully',
          enter_category_description: 'Enter category description',
          parent_category: 'Parent Category',
          none: 'None',
          cover_image: 'Cover Image',
          select_image: 'Select Image',
          select_meta_image: 'Select Meta Image',
          image_selected: 'Image selected',
          meta_image: 'Meta Image',
          seo_meta_data: 'SEO & Meta Data',
          meta_title: 'Meta Title',
          meta_description: 'Meta Description',
          select_parent: 'Select parent category',
          unknown: 'Unknown',
          image: 'Image',
          enter_page_title: 'Enter page title',
          enter_page_slug: 'Enter page slug',
          enter_meta_title: 'Enter meta title',
          enter_meta_description: 'Enter meta description',
          page_title: 'Page Title',
          page_slug: 'Page Slug',
          page_content: 'Page Content',
          start_typing_content: 'Start typing your page content here...',
          seo_optimization_settings: 'SEO & Meta Discovery',
          search_engine_title: 'Search Engine Title',
          search_engine_description: 'Search Engine Description',
          page_visibility: 'Page Status',
          update_page_btn: 'Save',
          publish_page_btn: 'Create',
          cancel_changes: 'Cancel',
          publishing_safety_desc:
            'Changes take effect immediately across all support interfaces. Avoid duplicate slugs to prevent routing issues.',
          update_page_description_form: 'Modify the page content and settings.',
          create_page_description_form: 'Create a new system page with rich content.',
          insights_updates: 'Insights & Updates',
          read_full_story: 'Read Full Story',
          view_post: 'View Post',
          ai_trends: 'AI Trends',
          marketing: 'Marketing',
          tutorials: 'Tutorials',
          ethics: 'Ethics',
          design: 'Design',
          productivity: 'Productivity',
          now_reading: 'Now Reading',
          contact_support_title: 'Contact Support',
          send_message: 'Send Message',
          message_sent_successfully: 'Your inquiry has been sent successfully!',
          no_results: 'No results.',
          no_results_found: 'No results found.',
          previous: 'Previous',
          next: 'Next',
          knowledge_base: 'Knowledge Base',
          contact_support_desc: "Can't find what you're looking for? Our support team is here to help you.",
          live_chat: 'Live Chat',
          loading_details: 'Fetching details...',
          no_results_description:
            "We couldn't find any articles matching your search. Try different keywords or contact support.",
          // Contacts
          enter_description: 'Enter description',
          // Errors
          description_required: 'Description is required',
          title_required: 'Title is required',
          // Testimonial
          testimonials_management: 'Testimonials',
          manage_user_testimonials_desc: 'Manage and display feedback from your valued users.',
          add_testimonial: 'Add Testimonial',
          edit_testimonial: 'Edit Testimonial',
          create_testimonial: 'Create Testimonial',
          update_testimonial: 'Update Testimonial',
          testimonial_created_successfully: 'Testimonial created successfully',
          testimonial_updated_successfully: 'Testimonial updated successfully',
          testimonial_deleted_successfully: 'Testimonial deleted successfully',
          testimonial_title_placeholder: 'Enter a headline for the testimonial',
          testimonial_description_placeholder: 'What did the user say about your service?',
          upload_user_photo: 'User Photo',
          delete_testimonial_title: 'Delete Testimonial',
          delete_testimonial_desc: 'Are you sure you want to delete this testimonial? This action cannot be undone.',
          search_testimonials: 'Search testimonials...',
          user_name: 'User Name',
          user_post: 'Designation / Company',
          user_name_placeholder: 'e.g. John Doe',
          user_post_placeholder: 'e.g. CEO at Acme Corp',
          upload_image: 'Upload Image',
          rating: 'Rating',
          created_at: 'Created At',
          // Delete Modal
          status_updated_successfully: 'Status updated successfully',
          deleting: 'Deleting',
          delete_faq_title: 'Delete FAQ',
          delete_faq_description: 'Are you sure you want to delete this FAQ? This action cannot be undone.',
          delete_confirmation: 'Delete Confirmation',
          delete_confirmation_message: 'Are you sure you want to delete this item? This action cannot be undone.',
          // Contact Inquiry
          contact_inquiry_title: 'Inquiries',
          contact_inquiry_desc: 'View and manage user contact inquiries.',
          contact_inquiry_deleted_successfully: 'Inquiry deleted successfully',
          failed_to_delete_inquiry: 'Failed to delete inquiry',
          no_inquiries_found: 'No inquiries found.',
          delete_inquiry_title: 'Delete Inquiry',
          delete_inquiry_description: 'Are you sure you want to delete this inquiry? This action cannot be undone.',
          subject: 'Subject',
          message: 'Message',
          // User Management
          manage_members: 'Manage your members here',
          create_member: 'Create Member',
          edit_member: 'Edit Member',
          user_created_successfully: 'User created successfully',
          user_updated_successfully: 'User updated successfully',
          user_deleted_successfully: 'User deleted successfully',
          enter_your_email: 'Enter your email',
          failed_to_delete_user: 'Failed to delete user',
          no_users_found: 'No users found.',
          delete_user_title: 'Delete User',
          delete_user_description: 'Are you sure you want to delete this user? This action cannot be undone.',
          role_required: 'Role is required',
          role: 'Role',
          select_role: 'Select Role',
          user: 'User',
          never: 'Never',
          inactive: 'Inactive',
          last_login: 'Last Login',
          assign_plan: 'Assign Plan',
          assign_plan_to_user: 'Assign Plan to User',
          select_user: 'Select User',
          search_user_by_name_or_email: 'Search user by name or email',
          select_plan: 'Select Plan',
          duration: 'Duration',
          cycles: 'Cycles',
          total_amount_override: 'Total Amount Override',
          plan_assigned_successfully: 'Plan assigned successfully',
          subscription_approved_success: 'Subscription approved successfully',
          subscription_approved_error: 'Failed to approve subscription',
          subscription_rejected_success: 'Subscription rejected successfully',
          subscription_rejected_error: 'Failed to reject subscription',
          search_subscriptions: 'Search subscriptions...',
          approve: 'Approve',
          reject: 'Reject',
          free_trial: 'Free Trial',
          no_expiration: 'No Expiration',
          trial_days: 'Trial Days',
          featured_plan: 'Featured Plan',
          featured_plan_desc: 'Highlight this plan in the pricing table',
          free_trial_configuration: 'Free Trial Configuration',
          configure_free_trial_for_new_users: 'Configure free trial settings for new users.',
          enable_free_trial: 'Enable Free Trial',
          allow_new_users_to_start_with_trial: 'Let new users begin with a free trial period.',
          trial_days_limit: 'Trial Duration (Days)',
          trial_period: 'Trial Period',
          // AI Chatbot Module
          back_to_dashboard: 'Back to Dashboard',
          creating: 'Creating',
          save_changes: 'Save Changes',
          saving: 'Saving...',
          api_key: 'API Key',
          enter_title: 'Enter title...',
          content: 'Knowledge Content',
          api_key_required: 'API key is required',
          custom: 'Custom Provider',
          powered_by: 'Powered by',
          preview_bot_response:
            'I can help you with that! Our platform provides cutting-edge AI tools to amplify your creativity and streamline your workflow. Shall we begin by choosing a model?',
          created: 'Created',
          // AI Chat List & Detail
          no_admin_chatbots_desc:
            'Try searching for something else or check back later for new specialized AI assistants.',
          back_to_list: 'Back to List',
          export_pdf: 'PDF',
          // Email Config
          configure_email_provider: 'Configure your email provider to send system emails and notifications.',
          email_provider: 'Email Provider',
          from_name: 'From Name',
          from_email: 'From Email',
          from_name_required: 'From Name is required',
          from_email_required: 'From Email is required',
          smtp_settings: 'SMTP Settings',
          smtp_host: 'SMTP Host',
          smtp_port: 'SMTP Port',
          smtp_user: 'SMTP User',
          smtp_pass: 'SMTP Password',
          encryption: 'Encryption',
          sendgrid_settings: 'SendGrid Settings',
          test_configuration: 'Test Configuration',
          save_configuration: 'Save Configuration',
          settings_title: 'Settings',
          notifications: 'Notifications',
          general: 'General',
          send_test_email: 'Send Test Email',
          enter_test_email_desc: 'Enter an email address to send a test email to verify your configuration.',
          recipient_email: 'Recipient Email',
          send_test: 'Send Test',
          campaign_name_required: 'Broadcast name is required',
          campaign_subject_required: 'Email subject is required',
          email_content_required: 'Email content is required',
          scheduled_at: 'Scheduled At',
          email_config_updated: 'Email configuration updated successfully',
          failed_to_update_email_config: 'Failed to update email configuration',
          test_email_sent: 'Test email sent successfully',
          failed_to_send_test_email: 'Failed to send test email',
          enter_test_email: 'Please enter a test email address',
          smtp_host_required: 'SMTP host is required',
          smtp_port_required: 'SMTP port is required',
          smtp_user_required: 'SMTP user is required',
          smtp_pass_required: 'SMTP password is required',
          encryption_required: 'Encryption is required',
          sendgrid_api_key_required: 'SendGrid API key is required',
          email_provider_required: 'Email provider is required',
          must_be_number: 'Must be a number',
          // Wizard Specific
          back: 'Back',
          pick_a_date: 'Pick a date',
          create_whatsapp_campaign_desc:
            'Create a new WhatsApp broadcast and choose whether to send it instantly or schedule it for later to maximize engagement.',
          create_telegram_campaign_desc:
            'Create a new Telegram broadcast and choose whether to send it instantly or schedule it for later to maximize engagement.',
          type_message_placeholder: 'Type the message you want to send to contacts',
          campaign_content_required: 'Broadcast content is required',
          at_least_one_contact_required: 'Select at least one contact',
          select_all: 'Select All',
          published: 'Published',
          ai_prompt_placeholder:
            'e.g. Write a friendly newsletter about our new summer collection launching this friday...',
          // Content Writer
          generate_to_start: 'Enter details and click generate to start.',
          start_writing: 'Start Writing',
          writer_save: 'Save',
          writer_copy: 'Copy',
          writer_history: 'History',
          writer_no_history: 'No history found',
          writer_result: 'Result',
          writer_date: 'Date',
          writer_template: 'Template',
          writer_actions: 'Actions',
          generation_failed: 'Generation failed',
          search_templates: 'Search templates...',
          bulk_add_desc:
            'Tell the AI what kind of outline you want. For example: "Focus more on the history" or "Include a section about pricing".',
          // Speech to Text
          change_file: 'Change File',
          remove: 'Remove',
          // File Chat
          edit_profile: 'Edit Profile',
          manage_profile: 'Manage your personal information and account settings.',
          update_profile: 'Update Profile',
          updating: 'Updating...',
          profile_updated: 'Profile updated successfully',

          //Settings
          app_information: 'App Information',
          app_name: 'App Name',
          app_description: 'App Description',
          app_email: 'App Email',
          support_email: 'Support Email',
          maintenance_title: 'Maintenance Title',
          maintenance_message: 'Maintenance Message',

          // Roles & Permissions
          roles_management: 'Permissions',
          manage_user_roles_and_permissions: 'Manage user roles, access levels and granular permissions.',
          add_role: 'Add Role',
          edit_role: 'Edit Role',
          module: 'Module',
          submodule: 'Submodule',
          access: 'Access',
          save: 'Save',
          roles_deleted_successfully: 'Roles deleted successfully',
          delete_role_title: 'Delete Role',
          delete_role_description:
            'Are you sure you want to delete this role? Users currently assigned to this role might lose access.',
          search_roles: 'Search for roles...',
          select_module: 'Select Module',
          select_submodule: 'Select Submodule',
          read: 'Read',
          write: 'Write',
          add_permission: 'Add Permission',
          no_permissions_assigned: 'No permissions assigned yet.',
          permissions_assigned_successfully: 'Permissions assigned successfully',
          edit_permissions: 'Edit Permissions',
          assign_submodules_and_select_access: 'Assign Submodules & Select Access',
          save_permissions: 'Save Permissions',
          assigned_permissions: 'Assigned Permissions',
          configuration: 'Configuration',
          value: 'Value',
          sync_credentials: 'Save Credentials',
          logo_branding: 'Logo Branding',
          manage_logos_desc: 'Manage Logos Description',
          manage_basic_app_details: 'Manage Basic App Details',
          maintenance_mode: 'Maintenance Mode',
          control_app_availability: 'Temporarily disable public access',
          allowed_ips: 'Allowed IPs (comma separated)',
          resource_limits: 'Resource Limits',
          set_upload_and_content_limits: 'Set Upload and Content Limits',
          system_pages: 'System Pages',
          profile_details: 'Profile Details',
          update_profile_info: 'Update your personal information',
          category: 'Category',
          select_category: 'Select Category',
          prompt: 'Prompt',
          recent_articles: 'Recent Articles',
          signing_out: 'Signing Out',
          free_plan: 'Free Plan',
          // Plans & Billing
          plans_management: 'Plans',
          manage_subscription_plans_and_pricing: 'Manage your subscription plans, pricing and feature limits.',
          add_plan: 'Add Plan',
          create_new_plan: 'Create New Plan',
          edit_plan: 'Edit Plan',
          update_plan: 'Update Plan',
          create_plan: 'Create Plan',
          configure_pricing_and_feature_access: 'Configure pricing, billing and feature access level.',
          synchronizing: 'Synchronizing',
          basic_info: 'Basic Info',
          plan_name: 'Plan Name',
          basic_info_tip:
            'Define the core identity of your plan. Slugs are used for internal identification and URL structures.',
          of: 'of',
          enter_plan_name: 'e.g. Professional',
          enter_plan_slug: 'e.g. professional-plan',
          enter_plan_description: 'Enter a short summary of the plan',
          billing_cycle: 'Billing Cycle',
          select_cycle: 'Select Cycle',
          monthly: 'Monthly',
          yearly: 'Yearly',
          set_as_default: 'Set as Default',
          default_plan_desc: 'New users will be automatically assigned to this plan.',
          active_status: 'Active Status',
          plan_status_desc: 'Only active plans are visible to users.',
          delete_plan_title: 'Delete Plan',
          delete_plan_description: 'Are you sure you want to delete this plan? This action cannot be undone.',
          plan_created_successfully: 'Plan created successfully',
          plan_updated_successfully: 'Plan updated successfully',
          plans_deleted_successfully: 'Plans deleted successfully',
          search_plans: 'Search plans...',
          mo: 'mo',
          yr: 'yr',
          pricing: 'Pricing',
          choose_your_plan: 'Choose Your Plan',
          flexible_plans_desc: 'Select the perfect plan for your business needs. Upgrade or downgrade at any time.',
          current_plan: 'Current Plan',
          subscribe: 'Subscribe',
          most_popular: 'Most Popular',
          billing_history: 'Billing History',
          manage_subscription: 'Manage Subscription',
          subscription_active: 'Your subscription is active until',
          cancel_subscription: 'Cancel Subscription',
          renew_automatically: 'Renews automatically',
          pay_monthly: 'Pay Monthly',
          pay_yearly: 'Pay Yearly',
          save_20: 'Save 20%',
          payment_successful: 'Payment Successful!',
          manage_user_subscriptions: 'Manage User Subscriptions',
          your_subscription_has_been_activated_successfully_redirecting_to_your_subscriptions:
            'Your subscription has been activated successfully. Redirecting to your subscriptions...',

          // Language Management
          languages_management: 'Language',
          manage_languages_desc: 'Manage application languages, locales, and translations.',
          quick_select_language: 'Quick Select Language',
          resource_file: 'Resource File',
          ready_to_sync: 'Ready to sync',
          drop_or_click_json: 'Drop or click to upload JSON',
          localized_strings_file: 'Localized strings file only',
          global_availability: 'Language Status',
          apply_updates: 'Apply Updates',
          build_language: 'Create Language',
          download_translation: 'Download Translation',
          please_select_a_language: 'Please select a language',
          add_language: 'Add Language',
          edit_language: 'Edit Language',
          language_name: 'Language Name',
          flag: 'Flag',
          language_created_successfully: 'Language created successfully',
          language_updated_successfully: 'Language updated successfully',
          language_deleted_successfully: 'Language deleted successfully',
          language_name_required: 'Language name is required',
          locale_required: 'Locale is required',
          no_languages_found: 'No languages found. Add one to get started.',
          delete_language_title: 'Delete Language',
          delete_language_description: 'Are you sure you want to delete this language? This action cannot be undone.',
          search_languages: 'Search languages...',
          lang_label: 'Language',
          default: 'Default',
          no_active_subscription: 'No Active Subscription',
          no_active_subscription_desc:
            "You don't have any active subscription. Please subscribe to a plan to get started.",
          plan: 'Plan',
          subscription_date: 'Subscription Date',
          expiry_date: 'Expiry Date',
          days_remaining: 'Days Remaining',
          payment_history: 'Transaction History',
          date: 'Date',
          gateway: 'Gateway',
          invoice_id: 'Invoice ID',
          no_subscription_history: 'No subscription history',
          subscription_history: 'Subscription History',
          manage_transaction_history: 'Manage your transaction history here.',
          search_transactions: 'Search transactions...',
          view_plans: 'View Plans',
          current_subscription: 'Current Subscription',
          amount_paid: 'Amount Paid',
          filter_by_status: 'Filter by Status',
          active_subscription_details: 'View your active subscription details',
          past_subscriptions: 'View all your past subscriptions',
          confirm_cancellation: 'Confirm Cancellation',
          keep_subscription: 'Keep Subscription',
          no_subscription_desc: 'You currently do not have an active subscription. Choose a plan to get started.',
          subscriptions_deleted_successfully: 'Subscriptions deleted successfully',
          back_to_plans: 'Back to Plans',
          cancel_at_period_end_desc: 'Your subscription is cancelled and will expire on {{date}}.',
          retain_access_until: "Are you sure you want to cancel? You'll retain access until {{date}}.",
          processing: 'Processing',
          members: 'Members',
          days_count: '{{count}} days',
          amount: 'Amount',
          member_count: 'Member Count',
          validity_days: 'Validity Days',
          all_status: 'All Status',
          search_members: 'Search Members',
          unknown_user: 'Unknown User',
          unknown_plan: 'Unknown Plan',
          cancelling: 'Cancelling',
          subscription_cancelled_successfully: 'Subscription cancelled successfully.',
          error_404_title: 'Page Not Found',
          error_404_desc: 'The page you are looking for does not exist or has been moved.',
          maintenance_mode_title: 'Under Maintenance',
          maintenance_mode_desc: 'We are performing some maintenance. Please check back later',
          maintenance_footer_msg: 'We apologize for any inconvenience. Normal service will resume shortly.',
          offline_title: 'No Internet Connection',
          offline_desc: 'It seems you are offline. Please check your internet connection and try again.',
          retry_now: 'Retry Now',
          retrying: 'Retrying...',
          back_to_home: 'Back to Home',
          new_registrations: 'New Registrations',
          search_pages: 'Search Pages',
          search_inquiries: 'Search Inquiries',
          search_faqs: 'Search FAQs',
          plan_limits: 'Plan Limits',
          total_credits: 'Total Credits',
          chatbot_creation_limit: 'Chatbot Creation Limit',
          publish_post_per_day: 'Publish Post Per Day',
          campaign_per_day: 'Broadcast Per Day',
          one_time: 'One Time',
          lifetime: 'Lifetime',

          // Social Media Suite
          social_security_desc:
            'Credentials are encrypted at rest. Never share your App Secret with unauthorized personnel or third-party services.',
          meta_app_config: 'Meta App Configuration',
          meta_app_id: 'Meta App ID',
          meta_app_secret: 'Meta App Secret',
          meta_api_version: 'API Version',
          save_config: 'Save Configuration',
          change_config: 'Change Configuration',
          meta_config_desc:
            'Configure your Meta application credentials to enable Facebook and Instagram integrations.',
          meta_id_required: 'Meta App ID is required',
          meta_secret_required: 'Meta App Secret is required',
          field_required: '{{field}} is required',
          connected_channels: 'Connected Channels',
          back_to_channels: 'Back to Channels',
          social_activity: 'Social Activity',
          social_activity_desc: 'Track your recent social media posts and their status.',
          search_activity: 'Search activity...',
          no_caption: 'No caption',
          video_motion: 'Video Motion',
          video_motion_desc: 'Add cinematic movement to your videos with advanced AI motion control.',
          start_motion_gen: 'Start Motion Generation',
          motion_prompt_placeholder:
            'Describe the motion you want to achieve (e.g., slow cinematic zoom, fast-paced transition)...',
          explore_motion_templates: 'Explore Motion Templates',
          use_motion_template: 'Use this Motion',
          generate_motion: 'Generate Motion',
          social_engagement_desc_candle:
            'Advanced engagement metrics showing daily activity fluctuations across your platforms.',
          social_engagement_desc_bar:
            'A clear view of your total daily interactions and engagement across all your platforms.',
          view_only: 'View Only',
          limits_per_section: 'Limits Per Section',
          credits_overview: 'Credits Overview',
          usage_progress: 'Usage Progress',
          total: 'Total',
          remaining: 'Remaining',
          user_dashboard_promo_unique:
            'Unify AI agents, human expertise, and marketing automation.Build, collaborate, and scale everything from one intelligent ecosystem.',
          good_morning: 'Good Morning',
          good_afternoon: 'Good Afternoon',
          good_evening: 'Good Evening',
          good_night: 'Good Night',
          demo_user_settings: 'Demo User Settings',
          set_demo_credentials: 'Configure credentials for the demo login',
          demo_user_email: 'Demo User Email',
          demo_user_password: 'Demo User Password',
          admin_demo: 'Admin Demo',
          user_demo: 'User Demo',
          media: 'Media',
          today: 'Today',
          channel: 'Channel',
          view: 'View',
          please_enter_prompt: 'Please enter prompt',
          email: 'Email',
          platform: 'Platform',
          marketing_bot_hero_desc:
            'Seamlessly broadcast messages on WhatsApp, Telegram, and Email using our intelligent and efficient platform.',
          canceled_expires: 'Canceled expires',
          get_started: 'Get Started',
          price: 'Price',
          days: 'Days',
          subscription_canceled_successfully: 'Subscription Canceled Successfully',
          plan_subtitle: 'Unlock the full potential of your business with our tailored pricing plans.',
          tags: 'Tags',
          credit_configuration: 'Credit Configuration',
          set_credits_for_various_ai_features: 'Define credit consumption for each AI capability across the platform',
          maintenance_image_url: 'Maintenance Image URL',
          press_enter_to_add_ip: 'Press Enter to add IP',
          please_enter_email: 'Please enter email',
          test_email_sent_successfully: 'Test email sent successfully',
          customize_error_pages: 'Customize Error Pages',
          image_url: 'Image URL',
          visual_opt_in_desc:
            'Enhance your article with an AI-generated image or skip this step to publish immediately.',
          name: 'Name',
          bulk_delete_warning: 'Are you sure you want to delete the selected items?',
          confirm_bulk_delete: 'Confirm Bulk Delete',
          bulk_delete: 'Bulk Delete',
          items_selected: 'Items selected',
          enter_subject: "What's this regarding?",
          subject_required: 'Subject is required',
          instagram_autoreply_only:
            'Tactical Alert: Auto-Reply sequence currently only compatible with Instagram nodes.',
          failed_to_update_payment_gateways: 'Failed to update payment gateways',
          payment_gateways_updated_successfully: 'Payment gateways updated successfully',
          failed_to_update_logos: 'Failed to update logos',
          logos_updated_successfully: 'Logos updated successfully',
          no_changes_to_save: 'No changes to save',
          failed_to_update_settings: 'Failed to update settings',
          settings_updated_successfully: 'Settings updated successfully',
          inquiries_deleted_successfully: 'Inquiries deleted successfully',
          failed_to_delete_inquiries: 'Failed to delete inquiries',
          faqs_deleted_successfully: 'Faqs deleted successfully',
          failed_to_delete_faqs: 'Failed to delete faqs',
          failed_to_update_profile: 'Failed to update profile',
          pages_deleted_successfully: 'Pages deleted successfully',
          failed_to_delete_pages: 'Failed to delete pages',
          branding: 'Branding',
          failed_to_delete_users: 'Failed to delete users',
          users_deleted_successfully: 'Users deleted successfully',
          delete_role: 'Delete Role',
          no_data_found: 'No data records identified',
          enter_password: 'Enter Password',
          old_password: 'Old Password',
          change_password: 'Change Password',
          password_changed_successfully: 'Password changed successfully',
          confirm_password_placeholder: 'Confirm Password',
          failed_to_change_password: 'Failed to change password',
          exhausted: 'Exhausted',
          neural_active: 'Active',
          module_limit_reached: 'Capacity reached for {{module}}. Please upgrade your plan.',
          active_plan: 'Active Plan',
          no_plan: 'No Plan',
          get_plan: 'Get Plan',
          days_left: 'Days Left',
          select_all_modules: 'Select All Modules',
          this_year: 'This Year',
          this_month: 'This Month',
          this_week: 'This Week',
          loading: 'Loading...',
          invalid_payment_confirmation_parameters: 'Invalid payment confirmation parameters',
          payment_confirmed_successfully: 'Payment confirmed successfully!',
          payment_confirmation_error: 'Payment confirmation error',
          failed_to_confirm_payment: 'Failed to confirm payment',
          no_payment_information_found: 'No payment information found',
          confirming_payment: 'Confirming Payment',
          please_wait_while_we_confirm_your_payment_and_activate_your_subscription:
            'Please wait while we confirm your payment and activate your subscription...',
          view_my_subscription: 'View My Subscription',
          synchronizing_gateways: 'Synchronizing Gateways...',
          active_providers: 'Active Providers',
          global_payment_settings_desc:
            'Securely manage your global payment provider credentials. These settings will be applied across all dynamic payment forms and checkout sessions.',
          payment_gateways: 'Payment Setup',
          access_restricted: 'Access Restricted',
          control_center: 'Control Center',
          manage_social_platform_api_keys_and_application_credentials:
            'Manage your social platform API keys and application credentials',
          the_payment_process_was_cancelled_no_charges_were_made_to_your_account:
            'The payment process was cancelled. No charges were made to your account.',
          filter_by_module_or_action: 'Filter by Module or Action',
          overall_progress: 'Overall Progress',
          your_subscription_has_been_activated_youll_be_redirected_shortly:
            "Your subscription has been activated. You'll be redirected shortly.",
          start_building_your_amazing_ai_powered_application: 'Start building your amazing AI-powered application.',
          smart_ai: 'Smart AI Content Generation Suite',
          analyzing_complexity_desc:
            'Analyzing complexity and generating high-performance {language} code via {model}.',
          select_language: 'Select Language',
          generate_forensic_report:
            'Generate a forensic report by pasting your content and clicking the verify button.',
          ai_powered: 'AI Powered',
          save_20_with_yearly_billing: 'Save 20% with yearly billing',
          total_due_today: 'Total Due Today',
          price_per_user: 'Price per User',
          total_amount: 'Total Amount',
          select_payment_method: 'Select Payment Method',
          choose_payment_method: 'Choose payment method',
          secure_encrypted_payments: 'Secure encrypted payments',
          multi_currency_supported: 'Multi-currency supported',
          checkout_in_progress: 'Checkout in Progress',
          please_complete_your_transaction_in_the_secure_razorpay_window:
            'Please complete your transaction in the secure Razorpay window.',
          cancel_or_choose_different_method: 'Cancel or Choose Different Method',
          finalizing_activation: 'Finalizing Activation',
          we_are_confirming_your_payment_with_the_gateway_this_will_just_take_a_moment:
            "We're confirming your payment with the gateway. This will just take a moment...",
          subscription_successful: 'Subscription Successful!',
          you_are_now_subscribed_to_the: "You're now subscribed to the",
          plan_your_access_is_active_immediately: 'plan. Your access is active immediately.',
          redirecting_to_payPal: 'Redirecting to PayPal',
          click_the_button_below_to_complete_your_subscription_with_payPal:
            'Click the button below to complete your subscription with PayPal.',
          open_payPal: 'Open PayPal',
          go_back: 'Go back',
          complete_payment: 'Complete Payment',
          secure_checkout: 'Secure checkout',
          trusted_payment_gateways: 'Trusted Payment Gateways',
          could_not_initialize_stripe_checkout: 'Could not initialize Stripe checkout.',
          could_not_initialize_razorpay_checkout: 'Could not initialize Razorpay checkout.',
          payment_initialization_failed: 'Payment initialization failed.',
          payment_for: 'Payment for',
          subscription_for: 'Subscription for',
          subscribe_to: 'Subscribe to',
          subscribe_to_plan: 'Subscribe to plan',
          this_is_the_default_plan_for_all_teams: 'This is the default plan for all teams.',
          what_you_get: 'What you get',
          review_the_plan_details_before_continuing: 'Review the plan details before continuing.',
          cost_breakdown: 'Cost Breakdown',
          proceed_to_payment: 'Proceed to payment',
          semantic_plagiarism_detection_across_web_and_databases:
            'Semantic plagiarism detection across web and databases',
          click_to_upload: 'Click to upload',
          admin_guidance: 'Admin Guidance',
          set_credits_for_various_ai_features_description:
            'Set these values based on your business model. For "Unlimited" or "Disabled" features, you can adjust these accordingly. Credits are deducted per successful generation or operation.',
          updating_credits: 'Updating Credits...',
          save_settings: 'Save Settings',
          provider_engine: 'Provider Engine',
          sender_identity: 'Sender Identity',
          global_payments: 'Global Payments',
          payPal: 'PayPal',
          mode: 'Mode',
          sandbox_testing: 'Sandbox (Testing)',
          client_id: 'Client ID',
          client_secret: 'Client Secret',
          important_paypal:
            "Note: Use Sandbox credentials for testing and switch to Live when you're ready to accept real payments.",
          indian_payments_hub: 'Indian Payments Hub',
          key_id: 'Key ID',
          key_secret: 'Key Secret',
          webhook_secret: 'Webhook Secret',
          important_razorpay:
            "Note: Use Sandbox credentials for testing and switch to Live when you're ready to accept real payments.",
          stripe: 'Stripe',
          important_stripe:
            "Note: Use Sandbox credentials for testing and switch to Live when you're ready to accept real payments.",
          razorpay: 'Razorpay',
          payment_processor: 'Payment Processor',
          publishable_key: 'Publishable Key',
          secret_key: 'Secret Key',
          pro_tip_stripe:
            'Note: Make sure to add your Webhook URL in Stripe Dashboard for recurring payments to work correctly.',
          system_email: 'System Email (OTP)',
          configure_smtp_server: 'Configure the SMTP server for system notifications like OTPs.',
          instruction: 'Instruction',
          when_setting_up_your_email_system:
            "When setting up your email system (SMTP), make sure to do it carefully. If it's not done right, you'll encounter errors when placing orders, registering new users, or sending newsletters.",
          if_you_are_not_using_ssl: "If you're not using SSL:",
          to_mail: 'To Mail',
          send_test_mail: 'Send Test Mail',
          if_you_are_using_ssl: "If you're using SSL:",
          test_mail: 'Test Mail',
          error_page_identity: '404 Page Identity',
          no_internet_identity: 'No Internet Identity',
          updating_brand: 'Updating Brand...',
          join_five_thousand_creators:
            'Join 5,000+ creators and agencies using Smart AI Content Generation Suite to publish smarter, grow faster.',
          retry: 'Retry',
          our_ai_handles_the_heavy_lifting_so_you_can_focus_on_growing:
            'our AI handles the heavy lifting so you can focus on growing',
          join_2000_businesses_using_ai_powered_whatsapp_telegram_and_email_automation_to_drive_real_growth:
            'Join 2,000+ businesses using AI-powered WhatsApp, Telegram and Email automation to drive real growth.',
          our_support_team_augmented_by_ai_answers_in_seconds:
            'Our support team — augmented by AI — answers in seconds.',
          everything_you_need_to: 'Everything you need to',
          ai_driven_tools_that_streamline_your_entire_marketing_workflow_from_lead_capture_to_final_sale:
            'AI-driven tools that streamline your entire marketing workflow — from lead capture to final sale.',
          scale_your_marketing_outreach_without_the_complexity_Choose_the_plan_that_fits_your_growth:
            'Scale your marketing outreach without the complexity. Choose the plan that fits your growth.',
          everything_you_need_to_create_schedule_and_optimise_social_media_content_powered_by_ai:
            'Everything you need to create, schedule and optimise social media content — powered by AI.',
          ai_powered_content_creation_desc:
            'Generate high-quality content tailored to your brand voice and audience preferences.',
          the_only_ai_powered_platform_designed_for_high_growth_social_media_presence:
            'The only AI-powered platform designed for high-growth social media presence.',
          get_started_free: 'Get Started Free',
          create_new_campaign_desc:
            'Create and launch stunning social media broadcasts effortlessly with automated workflows.',
          failed_to_download_image: 'Failed to download image',
          download: 'Download',
          connect_manage_and_streamline_all_your_social_platforms_in_one_place:
            'Connect, manage, and streamline all your social platforms in one place.',
          turn_ideas_into_posts_and_share_them_across_your_network_instantly:
            'Turn ideas into posts and share them across your network instantly.',
          create_customize_and_publish_engaging_content_across_your_social_platforms:
            'Create, customize, and publish engaging content across your social platforms.',
          configure_and_manage_your_AI_providers_and_API_integrations_in_one_place:
            'Configure and manage your AI providers and API integrations in one place.',
          action: 'Action',
          code_assistant_desc:
            'Build, customize, and generate code effortlessly with AI-powered assistance across multiple languages.',
          questions: 'Questions?',
          active_plans: 'Active Plans',
          get_template: 'Download Sample Template',
          campaign_hub_footer_desc:
            'Manage your broadcasts, track performance, and optimize your outreach efforts with ease.',
          standard_fields: 'Standard Fields',
          ready_to_drop: 'Ready to drop!',
          choose_a_file: 'Choose a file to upload',
          drag_drop_hint: 'or drag and drop it here',
          processing_data: 'Processing...',
          start_import: 'Start Import',
          valid_import_file_error: 'Please upload a valid .xlsx or .csv file',
          upload_instruction: 'Bring your data into Smart AI Content Generation Suite with a few clicks.',
          import_data: 'Import Data',
          setup_guide: 'Setup Guide',
          setup_guide_desc: 'To ensure successful import, please follow our template structure.',
          close: 'Close',
          view_subscriptions: 'View Subscriptions',
          no_payment_confirmation_status:
            'No payment confirmation parameters were found. Please check your subscription status.',
          upload_custom_flag: 'Upload Custom Flag',
          identity_locale: 'Identity Locale',
          visual_identity: 'Visual Identity',
          flag_icon_optional: 'Flag Icon (Optional)',
          remove_flag: 'Remove Flag',
          change_flag_icon: 'Change Flag Icon',
          recommended_size_160x100: 'Recommended size: 160x100px',
          at_least_one_contact_or_group_required: 'At least one contact or group is required.',
          locale_is_required: 'Locale is required.',
          name_is_required: 'Name is required.',
          json_file_is_required: 'JSON translation file is required.',
          invalid_locale: 'Invalid locale.',
          e_g_spanish: 'e.g. Spanish',
          file_format_extenstion: 'PNG, JPG or SVG (max 500KB)',
          create_new_language: 'Create New Language',
          this_language_is_not_our_system: 'This language is not in our system.',
          usd: 'USD ($)',
          inr: 'INR (₹)',
          eur: 'EUR (€)',
          gbp: 'GBP (£)',
          starts: 'Starts:',
          ends: 'Ends:',
          powering_our_intelligence: 'Powering your intelligence',
          xlsx_csv: 'XLSX / CSV',
          exit_focus: 'Exit Focus',
          focus_mode: 'Focus Mode',
          clear_all: 'Clear All',
          syncing_updates: 'Syncing updates...',
          stay_updated: 'Stay updated!',
          stay_updated_desc:
            "You don't have any notifications at the moment. We'll let you know when something happens.",
          manage_tags: 'Manage Tags',
          edit_tag: 'Edit Tag',
          delete_tag: 'Delete Tag',
          search_tags: 'Search tags...',
          select_tags: 'Select tags',
          tag_created_successfully: 'Tag created successfully',
          tag_updated_successfully: 'Tag updated successfully',
          tag_deleted_successfully: 'Tag deleted successfully',
          no_tag_found: 'No tag found',
          language_library: 'Language Library',
          add_new_language: 'Add New Language',
          modify_existing_locale: 'Modify the existing locale settings and configurations.',
          configure_new_localization: 'Configure a new localization for your application.',
          identity_and_locale: 'Identity & Locale',
          choose_language: 'Choose Language',
          custom_language: 'Custom Language',
          display_name: 'Display Name',
          'e.g._english': 'e.g. English',
          flag_icon: 'Flag Icon',
          change_flag_image: 'Change Flag Image',
          upload_flag_image: 'Upload Flag Image',
          custom_locale_code: 'Custom Locale Code',
          'e.g._pt-br': 'e.g. pt-br',
          system_translations: 'System Translations',
          front_end_json: 'Front End JSON',
          app_json: 'App JSON',
          select_translation_source: 'Select translation source',
          visibility_and_access: 'Visibility & Access',
          enable_for_users: 'Enable this language for all end users.',
          primary_system_language: 'Set as the primary system language.',
          right_to_left_layout: 'Enable right-to-left layout for this language.',
          configuration_tips: 'Configuration Tips',
          ensure_json_keys_match_defaults: 'Ensure JSON keys match system defaults.',
          use_high_res_flag_svg_best: 'Use high-resolution SVG flags for best quality.',
          rtl_automatically_flips_layout: 'RTL mode automatically flips the UI layout.',
          manage_translations: 'Manage Translations',
          edit_localization_keys_desc: 'Update individual translation keys for this language.',
          search_keys_or_values: 'Search keys or values...',
          no_keys_found: 'No translation keys found matching your search.',
          translations_updated_successfully: 'Translations updated successfully',
          failed_to_load_translations: 'Failed to load translations data',
          locale: 'Locale',
          rtl: 'RTL',
          yes: 'Yes',
          no: 'No',
          create_language: 'Create Language',
          update_language: 'Update Language',

          // Language Names
          English: 'English',
          French: 'French',
          Spanish: 'Spanish',
          German: 'German',
          Arabic: 'Arabic',
          Portuguese: 'Portuguese',
          Chinese: 'Chinese',
          Japanese: 'Japanese',
          Russian: 'Russian',
          Hindi: 'Hindi',
          Bengali: 'Bengali',
          Urdu: 'Urdu',
          Indonesian: 'Indonesian',
          Turkish: 'Turkish',
          Italian: 'Italian',
          Vietnamese: 'Vietnamese',
          Korean: 'Korean',
          Thai: 'Thai',
          Dutch: 'Dutch',
          // Payment Gateway
          payment_provider: 'Select Payment Provider',
          gateway_status_updated: 'Gateway status updated',
          gateway_toggle_error: 'Failed to toggle gateway status',
          gateway_stripe_updated: 'Stripe settings updated',
          gateway_stripe_update_error: 'Failed to update Stripe settings',
          gateway_paypal_updated: 'PayPal settings updated',
          gateway_paypal_update_error: 'Failed to update PayPal settings',
          gateway_razorpay_updated: 'Razorpay settings updated',
          gateway_razorpay_update_error: 'Failed to update Razorpay settings',
          gateway_test_success: 'Connection test successful!',
          gateway_test_failed: 'Connection test failed',
          gateway_test_error: 'Error testing connection',
          settings_loading: 'Loading settings...',
          test_connection: 'Test Connection',
          common_save_changes: 'Save Changes',
          gateway_active: 'Active',
          gateway_inactive: 'Inactive',
          // AI Providers
          ai_providers_title: 'AI Providers',
          ai_providers_desc: 'Manage your AI service provider configurations and API keys.',
          ai_provider_add_new: 'Add AI Provider',
          ai_provider_edit: 'Edit AI Provider',
          ai_provider_form_desc: 'Configure service endpoints, API keys, and job polling for each AI capability.',
          ai_provider_name: 'Provider Name',
          ai_provider_name_placeholder: 'e.g. Kling AI, Runway, Luma...',
          ai_provider_search_placeholder: 'Search providers...',
          ai_provider_services: 'Service Types',
          ai_provider_service_desc: 'Configure API credentials and endpoint details for this service.',
          ai_provider_services_configured: 'service(s) configured',
          ai_provider_ready: 'Provider is active and ready',
          ai_provider_enable_service: 'Enable Service',
          ai_provider_disable_service: 'Disable Service',
          ai_provider_service_disabled: 'Service Not Configured',
          ai_provider_service_disabled_desc:
            'Click "Enable Service" above to configure this capability for the provider.',
          ai_provider_core_config: 'Core Configuration',
          ai_provider_base_url: 'Base URL',
          ai_provider_auth_type: 'Auth Type',
          ai_provider_create_job: 'Job Creation Request',
          ai_provider_endpoint: 'Endpoint Path',
          ai_provider_method: 'HTTP Method',
          ai_provider_payload_template: 'Payload Template (JSON)',
          ai_provider_job_id_path: 'Job ID Path (dot notation)',
          ai_provider_poll_config: 'Poll Status Config',
          ai_provider_poll_endpoint: 'Poll Endpoint',
          ai_provider_state_path: 'State Path',
          ai_provider_success_state: 'Success State Value',
          ai_provider_failed_state: 'Failed State Value',
          ai_provider_result_url_path: 'Result Media URL Path',
          ai_provider_created_successfully: 'AI Provider created successfully',
          ai_provider_updated_successfully: 'AI Provider updated successfully',
          ai_provider_deleted_successfully: 'AI Provider deleted successfully',
          ai_provider_save_failed: 'Failed to save AI Provider',
          ai_provider_delete_failed: 'Failed to delete AI Provider',
          ai_provider_delete_title: 'Delete AI Provider',
          ai_provider_delete_desc: 'Are you sure you want to delete this AI Provider? This action cannot be undone.',
          ai_providers_empty_title: 'No AI Providers Yet',
          ai_providers_empty_desc: 'Add your first AI provider to start configuring service endpoints.',
          thumbnail_image: 'Thumbnail Image',
          enter_slug: 'Enter Slug',
          short_description: 'Short Description',
          enter_short_description: 'Enter short description',
          create_new_post: 'Create New Post',
          back_to_blogs: 'Back to Blogs',
          read_more: 'Read More',
          no_blogs_found: 'No blogs found',
          next_post: 'Next Post',
          previous_post: 'Previous Post',
          delete_tag_description: 'Are you sure you want to delete this tag? This action cannot be undone.',
          add_new: 'Add New',
          prompts_templates: 'AI Templates',
          manage_ai_prompt_templates: 'Manage AI prompt templates',
          add_template: 'Add Template',
          search_templates_placeholder: 'Search templates...',
          no_templates_found: 'No templates found',
          delete_template_title: 'Delete Template',
          delete_template_description:
            'Are you sure you want to delete this specific prompt template? This action cannot be undone.',
          template_updated_successfully: 'Template updated successfully',
          template_is_active: 'Template is active and visible',
          template_is_hidden: 'Template is hidden',
          all_fields_required: 'Title, category and prompt are required',
          upload_from_computer: 'Upload from computer',
          upload_first_media: 'Upload your first media',
          categories_title: 'Template Categories',
          categories_desc: 'Manage categories for your AI prompt templates.',
          create_category: 'Create Category',
          update_category: 'Update Category',
          create_template: 'Create Template',
          update_template: 'Update Template',
          text_to_image_desc: 'Transform your ideas into stunning visuals using AI',
          image_to_image_desc: 'Transform and evolve your images with AI',
          image_to_image_templates: 'Image to Image',
          select_starting_template_desc: 'Select a starting template or update an existing image using AI',
          create_blank_image_transformation: 'Transform New Image',
          reference_image: 'Reference Image',
          transformation_prompt: 'Transformation Prompt',
          image_to_image_placeholder:
            'How should I transform this image? e.g., make it cyberpunk style, add neon lights...',
          click_to_add_image: 'Click to add reference image',
          upload_from_library_or_pc: 'Upload from library or computer',
          transform_image: 'Transform Image',
          transformed_image_appear_here: 'Your transformed image will appear here',
          inspiration_templates: 'Inspiration Templates',
          please_select_reference_image: 'Please select or upload a reference image',
          text_to_video: 'Text to Video',
          text_to_video_desc: 'Turn your stories into cinematic videos with AI',
          create_blank_video: 'Create Blank Video',
          generate_video: 'Generate Video',
          generating_video: 'Generating Video...',
          video_generated_successfully: 'Video generated successfully!',
          video_appear_here: 'Your generated video will appear here',
          crafting_video: 'Crafting your video masterpiece...',
          image_to_video: 'Image to Video',
          image_to_video_desc: 'Animate your images into stunning videos with AI',
          create_blank_image_video: 'Create Image-to-Video',
          reference_images: 'Reference Images',
          please_select_at_least_one_image: 'Please select at least one reference image',
          no_categories_found: 'No Categories Found',
          edit_template: 'Edit Template',
          ai_features: 'AI Features',
          enable_ai_capabilities_for_this_plan: 'Enable AI Capabilities for this Plan',
          monthly_credits: 'Monthly Credits',
          images_to_video: 'Images to Video',
          total_subscriptions: 'Total Subscriptions',
          total_revenue: 'Total Revenue',
          current_subscriptions: 'Current Subscriptions',
          subscriptions_expired: 'Subscriptions Expired',
          expiring_soon: 'Expiring Soon',
          credits_usage: 'Credits Usage',
          consumed: 'Consumed',
          credits_reset_cycle: 'Credits reset every {{cycle}}',
          included_ai_features: 'Included AI Features',
          unlimited_access: 'Unlimited Access',
          not_included: 'Not Included',
          ai_capabilities: 'AI Capabilities',
          sync_to_gateways: 'Sync to Gateways',
          syncing_gateways: 'Syncing Gateways',
          sync_to_gateways_failed: 'Failed to sync to gateways',
          synced_to_gateways_successfully: 'Synced to gateways successfully',
          // Landing Page
          loved_by: 'Loved by',
          creators_everywhere: 'Creators Everywhere',
          testimonials_description:
            'Join thousands of satisfied users who are already scaling their content with Smart AI Content Generation Suite.',
          testimonials_badge: 'Wall of Love',
          next_gen_ai_platform: 'Next-Gen AI Platform',
          unleash_your: 'Unleash Your',
          creative_potential: 'Creative Potential',
          hero_subtitle:
            'The all-in-one AI platform to create, manage, and scale your social media presence with cinematic quality.',
          get_started_now: 'Get Started Now',
          explore_features: 'Explore Features',
          starter: 'Starter',
          pro: 'Pro',
          enterprise: 'Enterprise',
          starter_desc: 'Perfect for exploring the power of AI content creation.',
          pro_desc: 'Advanced tools for serious creators and small teams.',
          enterprise_desc: 'Scalable solutions for large agencies and organizations.',
          // Features
          '10_ai_images_/_mo': '10 AI Images / month',
          '100_chat_messages': '100 Chat Messages',
          basic_social_posts: 'Basic Social Posts',
          standard_support: 'Standard Support',
          unlimited_ai_images: 'Unlimited AI Images',
          unlimited_chat_messages: 'Unlimited Chat Messages',
          advanced_social_tools: 'Advanced Social Tools',
          priority_support: 'Priority Support',
          api_access: 'API Access',
          custom_ai_models: 'Custom AI Models',
          team_collaboration: 'Team Collaboration',
          dedicated_manager: 'Dedicated Manager',
          white_label_options: 'White-label Options',
          custom_training: 'Custom Training',
          start_test: 'Start Test',
          usage_limits: 'Usage Limits',
          search_blogs_placeholder: 'Search articles...',
          plan_deleted_successfully: 'Plan deleted successfully!',
          your_subscription_is_now_active: 'Your subscription is now active',
          payment_processed_successfully_no_charges_made_to_your_account:
            'Payment processed successfully. No charges were made to your account.',
          you_can_now_access_all_the_premium_features_of_your_plan:
            'You can now access all the premium features of your plan.',
          go_to_dashboard: 'Go to Dashboard',
          post_now: 'Post Now',
          no_caption_yet: 'No Caption Yet',
          preview_not_exact: 'Preview is not exact',
          select_accounts: 'Select Accounts',
          write_a_caption: 'Write a Caption',
          aspect_ratio: 'Aspect Ratio',
          update_category_details: 'Update the details for this category',
          create_category_details: 'Fill in the details to create a new category',
          category_image: 'Category Image',
          change_image: 'Change Image',
          view_all: 'View All',
          reference_video: 'Reference Video',
          creative_prompt: 'Creative Prompt',
          quality: 'Quality',
          your_name: 'Your Name',
          email_us: 'Email Us',
          available_24_7: 'Available 24/7',
          features: 'Features',
          social_media: 'Social Media',
          api_docs: 'API Docs',
          company: 'Company',
          about_us: 'About Us',
          our_blog: 'Our Blog',
          careers: 'Careers',
          privacy_policy: 'Privacy Policy',
          manage_landing_page: 'Manage Landing Page',
          hero: 'Hero',
          social: 'Social',
          blog: 'Blog',
          contact: 'Contact',
          footer: 'Footer',
          configure_your_public_interface_aesthetics: 'Configure your public interface aesthetics',
          refresh: 'Refresh',
          publish: 'Publish',
          changes_are_auto_saved_per_section: 'Changes are auto-saved per section',
          main_landing_header: 'Main Landing Header',
          highlight_key_values: 'Highlight Key Values',
          social_media_section: 'Social Media Section',
          subscription_plans: 'Subscription Plans',
          latest_articles: 'Latest Articles',
          customer_feedback: 'Customer Feedback',
          common_questions: 'Common Questions',
          get_in_touch_info: 'Get in Touch Info',
          footer_links: 'Footer Links',
          landing_page_updated_successfully: 'Landing page updated successfully',
          hero_configuration: 'Hero Configuration',
          main_landing_header_global_settings: 'Main Landing Header Global Settings',
          badge_text: 'Badge Text',
          enter_badge_text: 'Enter badge text',
          section_title: 'Section Title',
          enter_section_title: 'Enter section title',
          primary_cta: 'Primary CTA',
          e_g_get_started: 'e.g. Get Started',
          secondary_cta: 'Secondary CTA',
          e_g_view_demo: 'e.g. View Demo',
          hero_main_image: 'Hero Main Image',
          update_media: 'Update Media',
          click_to_browse_library: 'Click to browse library',
          features_configuration: 'Features Configuration',
          manage_features_section_content: 'Manage features section content',
          feature_items: 'Feature Items',
          feature_title: 'Feature Title',
          feature_description: 'Feature Description',
          accent_color: 'Accent Color',
          add_new_feature: 'Add New Feature',
          social_platforms_configuration: 'Social Platforms Configuration',
          manage_social_media_platforms_features: 'Manage social media platforms features',
          platform_name: 'Platform Name',
          platform_badge: 'Platform Badge',
          highlight_keyword: 'Highlight Keyword',
          platform_title: 'Platform Title',
          platform_features: 'Platform Features',
          add_platform_feature: 'Add Platform Feature',
          add_new_platform: 'Add New Platform',
          pricing_configuration: 'Pricing Configuration',
          manage_pricing_section_plans: 'Manage pricing section plans',
          select_plans: 'Select Plans',
          loading_plans: 'Loading plans...',
          select_plans_to_display: 'Select plans to display',
          blog_configuration: 'Blog Configuration',
          manage_blog_section_articles: 'Manage blog section articles',
          select_articles: 'Select Articles',
          loading_blogs: 'Loading blogs...',
          select_articles_to_display: 'Select articles to display',
          testimonials_configuration: 'Testimonials Configuration',
          manage_testimonials_section_content: 'Manage testimonials section content',
          select_testimonials: 'Select Testimonials',
          loading_testimonials: 'Loading testimonials...',
          select_testimonials_to_display: 'Select testimonials to display',
          faq_configuration: 'FAQ Configuration',
          manage_faq_section_questions: 'Manage FAQ section questions',
          select_faqs: 'Select FAQs',
          loading_faqs: 'Loading FAQs...',
          select_faqs_to_display: 'Select FAQs to display',
          contact_configuration: 'Contact Configuration',
          manage_contact_section_details: 'Manage contact section details',
          physical_address: 'Physical Address',
          live_chat_label: 'Live Chat Label',
          footer_configuration: 'Footer Configuration',
          manage_footer_content_links: 'Manage footer content links',
          footer_tagline: 'Footer Tagline',
          copyright_text: 'Copyright Text',
          add_social_link: 'Add Social Link',
          heading_is_required: 'Heading is required',
          subheading_is_required: 'Subheading is required',
          title_is_required: 'Title is required',
          description_is_required: 'Description is required',
          email_is_required: 'Email is required',
          tagline_is_required: 'Tagline is required',
          copyright_is_required: 'Copyright is required',
          wanna_join_channels: 'Wanna join channels?',
          connect_to_expand_reach: 'Expand your reach instantly',
          manage_all_accounts_in_settings: 'Manage all accounts in settings',
          coming_soon: 'Coming Soon',
          select_categories: 'Select Categories',
          testimonials: 'Testimonials',
          videos: 'Videos',
          subscribe_now: 'Subscribe Now',
          subscribed: 'Subscribed',
          start_free_trial: 'Start Free Trial',
          try_adjusting_your_search: 'Try adjusting your search',
          view_role: 'View Role',
          contact_email: 'Contact Email',
          contact_phone: 'Contact Phone',
          social_links: 'Social Links',
          contact_address: 'Contact Address',
          visibility_access: 'Visibility & Access',
          select_source: 'Select Source',
          drop_file: 'Drop file',
          usage_logs: 'Usage Logs',
          usage_logs_desc: 'Track your AI service activities and credit consumption.',
          service_type: 'Service Type',
          generated_media: 'Generated Media',
          used_credits: 'Used Credits',
          no_usage_logs_found: 'No usage logs found.',
          search_logs: 'Search logs...',
          running: 'Running',
          completed: 'Completed',
          failed: 'Failed',
          no_permission_usage_logs: 'You do not have permission to view AI usage logs.',
          past_due: 'Past Due',
          cancelled: 'Cancelled',
          expired: 'Expired',
          trialing: 'Trialing',
          changed: 'Changed',
          update_subscription: 'Update Subscription',
          success: 'Success',
          add_new_root_category: 'Add New Root Category',
          search_node: 'Search Node',
          all: 'All',
          generated: 'Generated',
          uploaded: 'Uploaded',
          latest_published_posts: 'Your recently published posts',
          pricing_description: 'Choose a plan that matches your creative workflow and unlock unlimited possibilities.',
          pricing_title: 'Simple Transparent',
          pricing_badge: 'LICENCE',
          contact_description: 'Ready to supercharge your content workflow? Send us a message and we’ll get back to you shortly.',
          join_our_community: 'Join Our Community',
          join_community_description: 'Connect with creators, share insights, and stay updated on the latest AI trends.',
          faq_description: 'Everything you need to know about our platform and how it can help you streamline your content creation process.',
          video: 'Video',
          images: 'Images',
          media_type: 'Media Type',
          ai_tools_features: 'AI Tools & Features',
          sound: 'Sound',
          ratio: 'Ratio',
          resolution: 'Resolution'
        },
      },
    },
    debug: false,
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], 
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
